import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

/** Project-detail layout — the canonical permalink (index) · F2/F3 Access. */
export const Route = createFileRoute('/_ws/w/$workspaceId/projects/$projectId')({
  beforeLoad: ({ params }) => {
    // Guard the id shape; a malformed path should 404, not hit the API.
    if (!/^[A-Za-z0-9_-]+$/.test(params.projectId)) throw notFound()
  },
  component: Outlet,
})
